import { Link, NavLink } from '@remix-run/react'
import { COPYRIGHT } from '~/config'
import { Wordmark } from '~/components'
import { LinkedInIcon, FormerlyKnownAsTwitterIcon, HiringIcon } from '../icons'
import { CallToAction } from '~/utils/a-b'
import { Accordion } from '~/components-v2'
import { useState, JSX } from 'react'

export const Footer = () => {
  const [capabilitiesToggle, setCapabilitiesToggle] = useState(false)
  const [compareToggle, setCompareToggle] = useState(false)
  const [learnToggle, setLearnToggle] = useState(false)
  const [partnersToggle, setPartnersToggle] = useState(false)

  interface accordionWrapperInterface {
    children: JSX.Element
    target: string
  }

  const AccordionWrapper = ({
    children,
    target,
  }: accordionWrapperInterface) => {
    const clickHandler = (target: string) => {
      if (target === 'Capabilities') {
        setCapabilitiesToggle(!capabilitiesToggle)
        setCompareToggle(false)
        setLearnToggle(false)
        setPartnersToggle(false)
      } else if (target === 'Compare Omni') {
        setCapabilitiesToggle(false)
        setCompareToggle(!compareToggle)
        setLearnToggle(false)
        setPartnersToggle(false)
      } else if (target === 'Learn') {
        setCapabilitiesToggle(false)
        setCompareToggle(false)
        setLearnToggle(!learnToggle)
        setPartnersToggle(false)
      } else if (target === 'Partners') {
        setCapabilitiesToggle(false)
        setCompareToggle(false)
        setLearnToggle(false)
        setPartnersToggle(!partnersToggle)
      }
    }

    return (
      <div className="hide-for-mobile" onClick={() => clickHandler(target)}>
        {children}
      </div>
    )
  }

  return (
    <footer className="app">
      <aside>
        <NavLink to="/">
          <Wordmark />
        </NavLink>
      </aside>

      <nav>
        <ul className="footer-links">
          <li>
            <h4>Product</h4>
            <NavLink to="/platform">Overview</NavLink>
            <NavLink to="/business-intelligence">Business Intelligence</NavLink>
            <NavLink to="/embedded-analytics">Embedded Analytics</NavLink>
            <NavLink to="/integrations">Integrations</NavLink>
            <NavLink to="/ai">AI</NavLink>
            <AccordionWrapper target="Capabilities">
              <Accordion open={capabilitiesToggle} title="Capabilities">
                <NavLink to="/calculations">Calculations</NavLink>
                <NavLink to="/data-modeling">Data Modeling</NavLink>
                <NavLink to="/data-input">Data Input</NavLink>
              </Accordion>
            </AccordionWrapper>
            <div className="reveal-for-mobile">
              <p>Capabilities</p>
              <div>
                <NavLink to="/calculations">Calculations</NavLink>
                <NavLink to="/data-modeling">Data Modeling</NavLink>
                <NavLink to="/data-input">Data Input</NavLink>
              </div>
            </div>
            <div className="reveal-for-mobile request-demo">
              <NavLink to="/request-demo">Request Demo</NavLink>
            </div>
          </li>
          <div>
            <li>
              <h4>Customers</h4>
              <NavLink to="/customer-case-studies">Case Studies</NavLink>
              <NavLink to="/customer-support">Customer Support</NavLink>
            </li>
            <li>
              <h4>Resources</h4>
              <AccordionWrapper target="Learn">
                <Accordion title="Learn" open={learnToggle}>
                  <a href="https://docs.omni.co">Documentation</a>
                  <a href="https://docs.omni.co/guides">User Guides</a>
                  <a href="https://community.omni.co/">Community</a>
                </Accordion>
              </AccordionWrapper>
              <div className="reveal-for-mobile">
                <p>Learn</p>
                <div>
                  <a href="https://docs.omni.co">Documentation</a>
                  <a href="https://docs.omni.co/guides">User Guides</a>
                  <a href="https://community.omni.co/">Community</a>
                </div>
              </div>
              <AccordionWrapper target="Partners">
                <Accordion title="Partners" open={partnersToggle}>
                  {/* <NavLink to="#">Partners Overview</NavLink> */}
                  <NavLink to="/snowflake">Omni + Snowflake</NavLink>
                  <NavLink to="/databricks">Omni + Databricks</NavLink>
                </Accordion>
              </AccordionWrapper>
              <div className="reveal-for-mobile">
                <p>Partners</p>
                <div>
                  {/* <NavLink to="#">Partners Overview</NavLink> */}
                  <NavLink to="/snowflake">Omni + Snowflake</NavLink>
                  <NavLink to="/databricks">Omni + Databricks</NavLink>
                </div>
              </div>
              <NavLink to="/demos">Demos</NavLink>
              <NavLink to="/changelog">Changelog</NavLink>
              <AccordionWrapper target="Compare Omni">
                <Accordion title="Compare Omni" open={compareToggle}>
                  <NavLink to="/omni-vs-tableau">Omni vs Tableau</NavLink>
                  <NavLink to="/omni-vs-looker">Omni vs Looker</NavLink>
                  <NavLink to="/omni-vs-sigma">Omni vs Sigma</NavLink>
                  <NavLink to="/omni-vs-metabase">Omni vs Metabase</NavLink>
                </Accordion>
              </AccordionWrapper>
              <div className="reveal-for-mobile">
                <p>Compare Omni</p>
                <div>
                  <NavLink to="/omni-vs-sigma">Omni vs Sigma</NavLink>
                  <NavLink to="/omni-vs-metabase">Omni vs Metabase</NavLink>
                  <NavLink to="/omni-vs-tableau">Omni vs Tableau</NavLink>
                  <NavLink to="/omni-vs-looker">Omni vs Looker</NavLink>
                </div>
              </div>
              <NavLink to="/security">Security</NavLink>
            </li>
            <li>
              <h4>Company</h4>
              <NavLink to="/about">About</NavLink>
              <NavLink to="/blog">Blog</NavLink>
              <a
                className="careers"
                href="https://exploreomni.rippling-ats.com/"
              >
                Careers <HiringIcon />
              </a>
              <a href="https://status.omniapp.co/">Status</a>
            </li>
          </div>
        </ul>
        <div className="footer-actions">
          <Link className="call-to-action size-md" to="/request-demo">
            Request Demo
          </Link>
          <CallToAction className="size-md" />
        </div>
      </nav>

      <div className="copy-and-social">
        <div className="copy-and-legal">
          <p>{COPYRIGHT}.</p>
          <p>
            <NavLink to="/privacy">Privacy</NavLink> |{' '}
            <NavLink to="/terms">Terms</NavLink>
          </p>
        </div>
        <ul>
          <li>
            <a
              href="https://www.linkedin.com/company/exploreomni/"
              rel="noreferrer noopener"
              target="_blank"
              aria-label="Omni on LinkedIn"
            >
              <LinkedInIcon />
            </a>
          </li>
          <li>
            <a
              href="https://twitter.com/Omni"
              rel="noreferrer noopener"
              target="_blank"
              aria-label="Omni on X"
            >
              <FormerlyKnownAsTwitterIcon />
            </a>
          </li>
        </ul>
      </div>
    </footer>
  )
}
